
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/commercial-broker",
      function () {
        return require("private-next-pages/investments/commercial-broker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/commercial-broker"])
      });
    }
  